'use strict';

var React = require('react'),
    AboutSection = require('../organisms/AboutSection'),
    Icon = require('../atoms/Icon'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    AboutSectionGrid = require('../organisms/AboutSectionGrid'),
    { PropTypes } = React;

const userpic = '//stampsy-eu-1.s3.amazonaws.com/uploads/production/24/06/2014/user/7/ef79a1ca-d39f-4708-93d1-0031838c02d4.jpg';
const stampPreviews = [
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/f78ebc30-2c58-47aa-8a67-b482829e07c3.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/649da9dc-159b-4261-97c9-6110c6e8ffff.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/11e65697-130d-477a-aa90-36652e9e9b7d.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/58a2b34f-eae7-45ef-8844-d445ede7e64d.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/63641ee8-2727-44d0-9a7a-87005719195e.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/2d09ccd3-7f03-4140-a200-f52baf5ac5c1.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/fc17923c-24dd-45e5-95d0-53467ae61d80.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/67bcfc4b-b2e5-48cd-ac7b-1c45c51fdc81.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/83e8a3b5-59c9-4cba-b7d3-f78adde05d28.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/630e78cd-7a45-47ab-b6c3-915e46586035.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/e78dce38-5a1b-4bbc-aef7-3cb045dccfb8.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/9dc562ce-2d9a-47d1-aabf-69b25ad5de1a.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/bb9ca7c4-565c-48f6-9cc5-8220785dfe0e.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5d3a8577-ca6c-4c9b-8af6-994016f1b28e.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/551572c2-cb83-4216-bb6f-c6266ed6dda0.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5a1f7319-7521-47e7-a792-41b29629efa9.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/8cb29bd2-d759-4e7a-8f6d-84c6a688f7b5.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/c4b30059-be35-4ea2-9d29-afd90479e8b6.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/72f4d28b-36d8-4ee9-8999-dcfba37a6137.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/daf9fc2d-21f3-4457-9818-17b937161865.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/37018538-adff-4aa2-b7d2-6145804f3db9.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/557c15db-1fa4-4f24-9b26-b5513da0d0ff.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/eb281f73-d609-4e47-9342-7de3b4083dab.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/a9095a72-3900-4103-a4ca-38a367bfcd8e.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/f87fb207-efbc-4ea0-9e07-7d78ba131a44.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/4519a07d-e9fa-44f6-863e-a6be63bed68e.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/dda8d3b7-87e4-4470-a1f0-0997b6a51148.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/1c9daac4-2f94-4b60-8dec-4167d78520e1.jpg'
];

require('./AboutFeedSection.less');

var AboutFeedSection = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    layout: PropTypes.any.isRequired,
    active: PropTypes.bool.isRequired
  },

  getCSSModifiers() {
    return {
      inactive: !this.props.active
    };
  },

  render() {
    const { active, layout } = this.props;
    return (
      <AboutSection layout={layout}
                    active={active}
                    title='Enjoy your personal magazine, filled with the things you care about.'
                    subtitle='Once you follow a collection, all of its stamps show up in your feed. Follow cool collections and discover extraordinary publications from the world’s top creators or stories from your friends.'
                    backgroundColor='#FF5252'
                    color='white'>
        <div className={this.getClassName()}>
          <div className='AboutFeedSection-navBar'>
            <div className='AboutFeedSection-logo'>
              <Icon name='logo'
                    size='small' />
            </div>
            <div className='AboutFeedSection-header'>
              Stampsy
            </div>

            <div className='AboutFeedSection-user'>
              <div className='AboutFeedSection-notification'>
                1
              </div>
              <div className='AboutFeedSection-userpic'>
                <img src={getThumbnailUrl({ url: userpic }, {
                  mode: 'scale_crop',
                  width: 18 * Math.round(
                    typeof window !== 'undefined'
                    ? window.devicePixelRatio
                    : 1
                  )
                })} />
              </div>
            </div>
          </div>
          <div className='AboutFeedSection-wrapper'>
            <AboutSectionGrid imageSize={{ width: 132 }}
                              imageUrls={stampPreviews}
                              active={active}
                              type='feed' />
          </div>
        </div>
      </AboutSection>
    );
  }
});

module.exports = AboutFeedSection;



/** WEBPACK FOOTER **
 ** ./organisms/AboutFeedSection.jsx
 **/